module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_8003.122ea15e.png";